// modules
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { addModal } from 'weblite-web-modal-viewer'
// component
import { OutDatedOs } from './out-dated-os'

const COMPONENT_ID = 'osOutDated'

export const showOutDatedOs = () => addModal({ id: COMPONENT_ID })

export default {
  [COMPONENT_ID]: {
    Component: OutDatedOs,
  },
}
